import Vue from 'vue';
import Router from 'vue-router';
import routes from '@/router/routes';
import store from '@/store/store';
import utils from '@/utils';
import { initializeAmplitude } from '@/analytics/reportExternalServiceError';

Vue.use(Router);

let isInited = false;

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routes
});

router.beforeEach((to, from, next) => {
  store.dispatch('setLoadingMain', true);

  // Derive proxy state from the URL on every navigation, including the first one —
  // isInited resets on reload, so the auth branch below always next()s early.
  if (to.query.proxyUserId) {
    store.dispatch('setReadOnlyMode', true);

    // Refresh mid-chat: proxyUserId is still in the query but the store is empty,
    // go back to /proxy to re-bootstrap.
    if (to.name !== 'proxy' && !store.state.user.effectiveSub) {
      next({ name: 'proxy', query: to.query });
      return;
    }
  } else {
    // No more proxyUserId in the URL, revert to normal mode
    store.dispatch('setReadOnlyMode', false);
    store.dispatch('setUser', { effectiveSub: '' });
  }

  // 初回は認証通るまでnext()しない
  if (!isInited) {
    isInited = true;

    const roleQuery = utils.getRoleQuery(to.query.r);
    const roleName = utils.getRoleName(roleQuery);
    const partnerRoleName = utils.getPartnerRoleName(roleQuery);

    if (!roleQuery) {
      goBack();
    }

    store.dispatch('setRole', {
      name: roleName,
      partnerName: partnerRoleName,
      query: roleQuery
    });

    initializeAmplitude(roleName);
    router.app.$auth.init(roleName);

    router.app.$auth
      .checkSession()
      .then(response => {
        if (process.env.VUE_APP_ENV !== 'production') {
          console.log(response);
        }
        store.dispatch('setAuthenticated', true);
        signInFirebase()
          .then(() => {
            if (!router.app.$firebase.getCurrentUser()) {
              goBack();
              return;
            }
            router.app.$firebase.updateProfile(store.state.user);
            store.dispatch('setLogined', true);
            next();
          })
          .catch(error => {
            if (process.env.VUE_APP_ENV !== 'production') {
              console.error(error);
            }
            goBack();
          });
      })
      .catch(error => {
        if (process.env.VUE_APP_ENV !== 'production') {
          console.error(error);
        }
        goBack();
      });
    return;
  }
  next();
});

router.afterEach((to, from) => {
  store.dispatch('setRoomQuery', {
    current: {
      partner: to.query.partner,
      project: to.query.project
    },
    old: {
      partner: from.query.partner,
      project: from.query.project
    }
  });
  router.app.$nextTick(() => {
    store.dispatch('setLoadingMain', false);
  });
});

function signInFirebase() {
  return router.app.$firebase.getRestoredUser().then(user => {
    // FirebaseのuidはAuth0のsubなので、同じユーザーのセッションが残っていればそのまま使う
    if (user && user.uid === store.state.user.sub) {
      return;
    }
    // Firebaseのカスタムトークンを取得する
    return router.app.$firebase
      .getToken(store.state.user.idToken, store.state.role.name)
      .then(response => {
        if (process.env.VUE_APP_ENV !== 'production') {
          console.log(response.data);
        }
        return router.app.$firebase.setToken(response.data.customToken);
      });
  });
}

function goBack() {
  location.href = utils.getBackUrl(store.state.role.name);
}

export default router;
